import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, Youtube, Mail } from "lucide-react";
import { EMAIL, NAV, OFFICES, PHONES, PRIVACY, SOCIALS } from "@/lib/content";

const ICONS = { LinkedIn: Linkedin, Instagram, Facebook, YouTube: Youtube };
const LEGAL = [
  { label: "Privacy Policy", href: PRIVACY },
  { label: "Accessibility Statement", href: "#accessibility-statement" },
  { label: "Terms & Conditions", href: "#terms-and-conditions" },
  { label: "Refund Policy", href: "#refund-policy" },
];

const Col = ({ title, children }) => (
  <div><p className="font-mono-ega text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">{title}</p>{children}</div>
);

const SocialLink = ({ social }) => {
  const Icon = ICONS[social.name];
  return <a href={social.href} target="_blank" rel="noopener noreferrer" aria-label={social.name} data-testid={`footer-social-${social.name.toLowerCase()}`} className="grid h-11 w-11 place-items-center rounded-full border border-[#E8F3EE]/20 transition-colors duration-300 hover:bg-[#D4AF37] hover:text-[#082F24] hover:border-[#D4AF37]"><Icon className="h-4 w-4" /></a>;
};

export const FooterBrand = () => (
  <div className="md:col-span-4">
    <img data-testid="footer-brand-logo" src="/assets/ega-logo-vertical-transparent.png" alt="Emerald Global Advisory" width="500" height="500" loading="lazy" className="w-44 h-auto object-contain" />
    <p data-testid="footer-brand-message" className="mt-6 text-sm text-[#E8F3EE]/80 max-w-xs leading-relaxed">Clearer numbers. More confident decisions. A finance partnership for women-led and purpose-driven businesses in the US and UK.</p>
    <div className="mt-6 flex gap-2">{SOCIALS.map((social) => <SocialLink key={social.name} social={social} />)}</div>
  </div>
);

export const FooterExplore = () => (
  <div className="md:col-span-2"><Col title="Explore"><ul className="space-y-3 text-sm">
    {NAV.map((item) => <li key={item.to}><Link to={item.to} data-testid={`footer-nav-${item.label.toLowerCase()}`} className="hover:text-[#D4AF37] transition-colors">{item.label}</Link></li>)}
  </ul></Col></div>
);

export const FooterContact = () => (
  <div className="md:col-span-3"><Col title="Talk to us">
    <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-2 text-sm hover:text-[#D4AF37] transition-colors break-all"><Mail className="h-4 w-4 shrink-0" />{EMAIL}</a>
    <ul className="mt-4 space-y-2 text-sm">{PHONES.map((phone) => <li key={phone.region}><a href={phone.href} data-testid={`footer-phone-${phone.region.toLowerCase()}`} className="hover:text-[#D4AF37] transition-colors"><span className="font-mono-ega text-xs text-[#D4AF37] mr-2">{phone.region}</span>{phone.number}</a></li>)}</ul>
  </Col></div>
);

export const FooterOffices = () => (
  <div className="md:col-span-3"><Col title="Registered offices"><div className="space-y-4 text-sm text-[#E8F3EE]/85 leading-relaxed">
    {OFFICES.map((office) => <p key={office.region} data-testid={`footer-office-${office.region.toLowerCase().replaceAll(" ", "-")}`}><span className="block text-[#FAF8F5] font-medium">{office.label}</span>{office.address}</p>)}
  </div></Col></div>
);

export const FooterLegal = () => (
  <div className="mt-6 border-t border-[#E8F3EE]/15 pt-6 flex flex-col lg:flex-row gap-4 justify-between text-xs text-[#E8F3EE]/70">
    <div className="flex flex-wrap gap-x-5 gap-y-2">{LEGAL.map((item) => <a key={item.label} href={item.href} target={item.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid={`footer-legal-${item.label.split(" ")[0].toLowerCase()}`} className="hover:text-[#D4AF37] transition-colors">{item.label}</a>)}</div>
    <p data-testid="footer-copyright">Copyright © 2026 EmeraldGlobalAdvisory.com. All Rights Reserved.</p>
  </div>
);